import { api } from './api';

export interface Company {
  id: string;
  name: string;
  email: string;
  phone?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  taxId?: string | null;
  logo?: string | null;
  logoBase64?: string | null;
  currency: string;
  fiscalYearStart: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateCompanyProfileData {
  name: string;
  email: string;
  phone?: string;
  address?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  taxId?: string;
  currency?: string;
  fiscalYearStart?: string;
}

export const companyService = {
  // Get company profile
  getProfile: async (): Promise<Company> => {
    const response = await api.get('/company/profile');
    return response.data.data;
  },

  // Update company profile
  updateProfile: async (data: UpdateCompanyProfileData): Promise<Company> => {
    const response = await api.put('/company/profile', data);
    return response.data.data;
  },

  // Upload company logo
  uploadLogo: async (file: File): Promise<Company> => {
    const formData = new FormData();
    formData.append('logo', file);

    const response = await api.post('/company/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data;
  },

  // Delete company logo
  deleteLogo: async (): Promise<Company> => {
    const response = await api.delete('/company/logo');
    return response.data.data;
  },

  // Get logo URL
  getLogoUrl: (logo: string | null | undefined): string | null => {
    if (!logo) return null;
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5002/api';
    const baseUrl = apiUrl.replace('/api', '');
    return `${baseUrl}/${logo}`;
  },
};
